// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DraggableColumns_wrapper__jnlbB","container":"DraggableColumns_container__XRKmJ","desc":"DraggableColumns_desc__IK5zG","dragPane":"DraggableColumns_dragPane__btJQO"};